import { useEffect, useState } from 'react';
import SelectItem from '../general-components/SelectItem';
import styles from './Brand.module.css';
import { addManufacturer } from '../../services/apiService';
import Button, { ButtonType } from '../general-components/Button';

const CustomManufacturerInput: React.FC<{
    info: any;
    manufacturerString: string;
    onUpdateInfoField: Function;
    onSave: Function;
}> = ({ info, manufacturerString, onUpdateInfoField, onSave }) => {
    const [newManufacturer, setNewManufacturer] = useState(info);
    const [isSaving, setIsSaving] = useState(false);

    const saveManufacturer = async () => {
        setIsSaving(true);
        await addManufacturer(newManufacturer);
        onUpdateInfoField(manufacturerString, newManufacturer);
        await onSave?.();
        setIsSaving(false);
    };

    return (
        <div className={styles.customManufacturerInput}>
            <input
                value={newManufacturer}
                type="text"
                placeholder="Add custom brand"
                required
                onChange={(e) => setNewManufacturer(e.target.value)}
            />
            <Button
                loading={isSaving}
                className={styles.saveButton}
                small
                type={ButtonType.primary}
                onClick={saveManufacturer}
            >
                Save
            </Button>
        </div>
    );
};

const Brand = ({
    fetchManufacturers,
    manufacturers,
    isCustomManufacturer,
    info,
    manufacturerString,
    onUpdateInfoField,
    toggleCustomManufacturer,
}: {
    fetchManufacturers?: Function;
    manufacturers: any[];
    isCustomManufacturer: boolean;
    info: any;
    manufacturerString: string;
    onUpdateInfoField: Function;
    toggleCustomManufacturer: Function;
}) => {
    const onSave = async () => {
        await fetchManufacturers?.();
        toggleCustomManufacturer(false);
    };

    return (
        <div className={`${styles.brand}`}>
            <label className={`${styles.infoLabel} ${styles.required}`}>
                Brand
            </label>
            {isCustomManufacturer && (
                <CustomManufacturerInput
                    info={info}
                    onSave={onSave}
                    manufacturerString={manufacturerString}
                    onUpdateInfoField={onUpdateInfoField}
                />
            )}
            {!isCustomManufacturer && (
                <select
                    name={manufacturerString}
                    value={info || ''}
                    required
                    onChange={(e) =>
                        onUpdateInfoField(manufacturerString, e.target.value)
                    }
                >
                    <option value="" disabled>
                        Select manufacturer
                    </option>
                    {manufacturers.map((m) => (
                        <option key={m.name}>{m.name}</option>
                    ))}
                </select>
            )}
            <div className={styles.typeCheckboxWrapper}>
                <Button
                    className={styles.saveButton}
                    small
                    type={ButtonType.primary}
                    onClick={() => {
                        onUpdateInfoField(manufacturerString, '');
                        toggleCustomManufacturer((prev: boolean) => !prev);
                    }}
                >
                    {!isCustomManufacturer
                        ? 'Create new manufacturer'
                        : 'Select existing manufacturer'}
                </Button>
            </div>
        </div>
    );
};

export default Brand;
